import Modal from 'react-modal'

let appRoot

const modalSetup = {
  setAppElement: (element) => {
    if (element) {
      Modal.setAppElement(element)
      appRoot = element
    }
  },
  getAppElement: () => appRoot,
}

export default modalSetup
